@if (order) {
  <div>
    <div class="table-actions">
      <div>
        <div>{{ 'URGENCY' | translate }}</div>
        <div>
          <dx-select-box
            [items]="urgencies$ | async"
            [(value)]="this.order.urgency.id"
            [displayExpr]="getUrgencyFieldName()"
            valueExpr="id"
            valueChangeEvent="keyup"
            [disabled]="orderUIService.isDisabled(order)">
            <dx-validator>
              <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
      </div>
      @if (this.order && this.order.coordinator && showCoordinator) {
        <div>
          <div>{{ 'COORDINATOR' | translate }}</div>
          <div>
            <dx-select-box
              [items]="(coordinators$ | async)?.result"
              [(value)]="this.order.coordinator.id"
              displayExpr="fio"
              valueExpr="id"
              valueChangeEvent="keyup"
              [disabled]="orderUIService.isDisabled(order) && this.order.status.id != _orderStatuses.SelectingACoordinator">
              <dx-validator>
                <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
              </dx-validator>
            </dx-select-box>
          </div>
        </div>
      }
      <div>
        <div>{{ 'WILL_BE_DONE' | translate }}</div>
        <div>
          <b>
            {{ order.expectExecDate | date: 'dd-MM-yyyy HH:mm:ss' }}
          </b>
        </div>
      </div>
    </div>
  </div>
}
